import React, { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MainLayout from "../components/layout/MainLayout";
import Breadcrumbs from "../components/common/Breadcrumbs";
import Swal from "sweetalert2";
import SanaNoteList from "../pages/Phase-05/SanaNote/SanaNoteList";
import {
    fetchSanaNotes,
    deleteSanaNote,
} from "../store/slices/sanaNotesSlice"; // Adjust the path
import { selectHasPermission } from "../store/slices/authSlice";

const SanaNotes = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { sanaNotes, isLoading, error } = useSelector((state) => state.sanaNotes);

    // Permissions
    const canManage = useSelector((state) =>
        selectHasPermission(state, "sana-note-manage")
    );
    const canCreate = useSelector((state) =>
        selectHasPermission(state, "sana-note-create")
    );
    const canEdit = useSelector((state) =>
        selectHasPermission(state, "sana-note-edit")
    );
    const canDelete = useSelector((state) =>
        selectHasPermission(state, "sana-note-delete")
    );

    // Fetch all records
    useEffect(() => {
        dispatch(fetchSanaNotes());
    }, [dispatch]);

    // Routing
    const handleAdd = () => navigate("/phase05/sana-notes/add");
    const handleEdit = (id) => navigate(`/phase05/sana-notes/edit/${id}`);

    // Delete
    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "This Progress Note will be deleted permanently!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        });

        if (result.isConfirmed) {
            dispatch(deleteSanaNote(id));
            Swal.fire("Deleted!", "Record has been removed.", "success");
        }
    };

    if (!canManage)
        return (
            <Navigate
                to="/dashboard"
                state={{ error: "You do not have permission to manage Progress Notes." }}
                replace
            />
        );

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />

                {error && (
                    <div className="alert alert-danger alert-dismissible fade show" role="alert">
                        <strong>Error:</strong> {error}
                        <button type="button" className="btn-close" onClick={() => { }}></button>
                    </div>
                )}

                <div className="card">
                    <div className="card-body">
                        <SanaNoteList
                            records={sanaNotes}
                            loading={isLoading}
                            onAdd={canCreate ? handleAdd : null}
                            onEdit={canEdit ? handleEdit : null}
                            onDelete={canDelete ? handleDelete : null}
                        />
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default SanaNotes;
